export function getTodayIsoDate(): string {
  return new Date().toISOString().split('T')[0];
}

export function normalizeDirection(
  value: string | null,
): 'outbound' | 'inbound' | null {
  const normalizedValue = value?.toLowerCase();

  if (normalizedValue === 'outbound' || normalizedValue === 'inbound') {
    return normalizedValue;
  }

  return null;
}

export function getDirectionFromHref(
  href: string | null,
): 'outbound' | 'inbound' {
  if (!href) {
    return 'outbound';
  }

  const [pathPart] = href.split('?');
  const hasProtocol = /^https?:\/\//i.test(pathPart);
  const url = new URL(hasProtocol ? href : `https://widget.local${href}`);
  const direction = normalizeDirection(url.searchParams.get('direction'));

  return direction ?? 'outbound';
}

export function getDateFromHref(href: string | null): string {
  if (!href) {
    return getTodayIsoDate();
  }

  const [pathPart] = href.split('?');
  const hasProtocol = /^https?:\/\//i.test(pathPart);
  const url = new URL(hasProtocol ? href : `https://widget.local${href}`);
  return url.searchParams.get('date') ?? getTodayIsoDate();
}

export function buildTimetableHref(
  templateHref: string,
  params: { direction: 'outbound' | 'inbound'; date: string },
): string {
  const hrefWithoutTemplate = templateHref.replace(/\{[?&][^}]+\}/g, '');
  const [pathPart, queryPart = ''] = hrefWithoutTemplate.split('?');
  const query = new URLSearchParams(queryPart);

  query.set('direction', params.direction);
  query.set('date', params.date);

  const queryString = query.toString();
  return queryString ? `${pathPart}?${queryString}` : pathPart;
}
